import { Divider } from "../../../../components/Divider/index.js";
import { AffiliationError } from "./AffiliationError/index.js";
import { AffiliationErrorsTypeProps } from "./types.js";
import { useTranslation } from "../../../../../customHooks/useTranslation/index.js";
import { getErrorTypeText } from "../../../../../entities/AffiliationError/helpers/getErrorTypeText.js";
import { Flex } from "waapi/waap-ui/components/Flex/Flex.js";
import { ICONSAX_SIZE } from "waapi/waap-ui/components/Iconsax/Iconsax.types.js";
import { RecordBold } from "waapi/waap-ui/components/Iconsax/RecordBold.js";
import { Text } from "waapi/waap-ui/components/Text/Text.js";
import { TextSize, TextWeight } from "waapi/waap-ui/components/Text/Text.types.js";
import { StyledFlex } from "./styles.js";

export const AffiliationErrorsType = (props: AffiliationErrorsTypeProps): JSX.Element => {
    const { t, translations } = useTranslation();
    const { errorType, affiliationErrors } = props;

    const errorTypeText = getErrorTypeText({ t, translations, errorType });

    return (
        <Flex direction="column" gap="16">
            <StyledFlex direction="row" gap="8" align="center">
                <RecordBold size={ICONSAX_SIZE.SMALL} />
                <Text size={TextSize.MEDIUM} weight={TextWeight.BOLD}>
                    {errorTypeText}
                </Text>
            </StyledFlex>
            <Flex gap="16" direction="row">
                {affiliationErrors.map((affiliationError) => (
                    <AffiliationError affiliationError={affiliationError} key={affiliationError._id} />
                ))}
            </Flex>
            <Divider />
        </Flex>
    );
};
